import { factory, stateList } from '@store/utils'
import { groupByProp } from '@utils/collections'

export const FACT_TYPES = {
  KEY_POINTS: 'KEY_POINTS',
  OUTLINE: 'OUTLINE',
  RECOMMENDATIONS_ALL: 'RECOMMENDATIONS_ALL',
  RELATED_ARTICLES: 'RELATED_ARTICLES',
  REQUIREMENTS_ALL: 'REQUIREMENTS_ALL',
  SOURCES: 'SOURCES',
  TOPIC_QUESTIONS: 'TOPIC_QUESTIONS',

  QUESTIONS_ANSWERS: 'QUESTIONS_ANSWERS',
  REQUIREMENTS_DESKTOP: 'REQUIREMENTS_DESKTOP',
  REQUIREMENTS_LAPTOP: 'REQUIREMENTS_LAPTOP',
}

// TODO: use i18n
const factTypes = [
  {
    label: 'Key facts',
    value: FACT_TYPES.KEY_POINTS,
    hasDraft: false,
    dependsOn: [],
    factory: () => '',
  },
  {
    label: 'Outline',
    value: FACT_TYPES.OUTLINE,
    hasDraft: false,
    dependsOn: [],
    factory: () => '',
  },
  {
    label: 'Recommendations',
    value: FACT_TYPES.RECOMMENDATIONS_ALL,
    hasDraft: false,
    dependsOn: [],
    factory: () => ({
      name: '',
      recommendations: [],
    }),
  },
  {
    label: 'Requirement list',
    value: FACT_TYPES.REQUIREMENTS_ALL,
    hasDraft: false,
    dependsOn: [],
    factory: () => ({
      name: '',
      recommendations: [],
    }),
  },
  {
    label: 'Topic questions',
    value: FACT_TYPES.TOPIC_QUESTIONS,
    hasDraft: false,
    dependsOn: [],
    factory: () => '',
  },
  {
    label: 'Related articles',
    value: FACT_TYPES.RELATED_ARTICLES,
    hasDraft: false,
    dependsOn: [],
    factory: () => '',
  },
  {
    label: 'Sources',
    value: FACT_TYPES.SOURCES,
    hasDraft: false,
    dependsOn: [],
    factory: () => '',
  },

  // NOTE: no longer used
  {
    label: 'Questions answers',
    value: FACT_TYPES.QUESTIONS_ANSWERS,
    hasDraft: false,
    dependsOn: [],
    factory: () => ({
      question: '',
      answer: '',
      brief: '',
    }),
  },
  {
    label: 'Desktop requirements',
    value: FACT_TYPES.REQUIREMENTS_DESKTOP,
    hasDraft: true,
    dependsOn: [],
  },
  {
    label: 'Laptop requirements',
    value: FACT_TYPES.REQUIREMENTS_LAPTOP,
    hasDraft: false,
    dependsOn: [
      FACT_TYPES.REQUIREMENTS_DESKTOP,
    ],
  },
]

export default {
  auto: '*',

  // indexes: [
  //   {
  //     fields: ['sectionId'],
  //     isMultiple: true,
  //   },
  // ],

  // for perf
  isFrozen: true,

  store: {
    getters: {
      factFactory: factory(() => ({
        articleId: null,
        siteId: null,
        sectionId: null,
        type: null,
        items: [],
        sources: [],
      })),
      FACT_TYPES: () => FACT_TYPES,
      factTypes: () => factTypes,
      factTypesByKey: (_, { factTypes }) => Object.fromEntries(factTypes
        .map(factType => [factType.value, factType])),

      factsBySectionId: state => groupByProp(
        'sectionId',
        Object.values(stateList(state)),
      ),
    },
  },
}
